import { PriceCalculation, print_price } from "./script/price.js";
import { get_nights_info } from "./script/time.js";
import {easepick, LockPlugin, RangePlugin} from "@easepick/bundle";


// Parcel hot reloading.

if (!!module && !!module.hot)
    module.hot.accept();


// Leaflet stuff (for the map)

function init_map_component() {
    const coordinate = [51.26184, 8.53215];
    const zoom_level = 13;

    const map = L.map('map').setView(coordinate, zoom_level);

    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(map);
    L.marker(coordinate).addTo(map);
}


// Set up the Blue Imp gallery... (https://github.com/blueimp/Gallery)

function init_gallery() {
    const room_basic_more_pictures = [
        new URL("assets/room_basic/bedroom1.jpg", import.meta.url),
        new URL("assets/room_basic/bedroom1_2.jpg", import.meta.url),
        new URL("assets/room_basic/television.jpg", import.meta.url),
        new URL("assets/room_basic/bedroom3.jpg?height=1000", import.meta.url),
        new URL("assets/room_basic/bedroom3_2.jpg?height=1000", import.meta.url),
        new URL("assets/room_basic/balcony.jpg", import.meta.url),
        new URL("assets/room_basic/environment.jpg", import.meta.url),
        new URL("assets/room_basic/bedroom2.jpg?height=1000", import.meta.url),
        new URL("assets/room_basic/bathroom2.jpg?height=1000", import.meta.url),
        new URL("assets/room_basic/bathroom.jpg?height=1000", import.meta.url),
        new URL("assets/room_basic/bedroom4.jpg?height=1000", import.meta.url),
        new URL("assets/room_basic/bathroom3.jpg?height=1000", import.meta.url)
    ];

    const room_family_more_pictures = [
        new URL("assets/room_family/room2_bunk_bed.jpg?height=1000", import.meta.url),
        new URL("assets/room_family/room2.jpg?height=1000", import.meta.url),
        new URL("assets/room_family/room2_2026_august_bathroom.jpg?height=1000", import.meta.url),
        new URL("assets/room_family/room1_bed_focus_v2.jpg", import.meta.url),
        new URL("assets/room_family/room1_2026_august.jpg", import.meta.url),
        new URL("assets/room_family/room1_2026_august_2.jpg", import.meta.url),
        new URL("assets/room_family/room1_corner.jpg", import.meta.url),
        new URL("assets/room_family/open_door_v2.jpg", import.meta.url),
        new URL("assets/room_family/room1_bathroom.jpg?height=1000", import.meta.url),
        new URL("assets/room_family/squirrel.jpg?height=1000", import.meta.url)
    ];

    const ferienwohnung_more_pictures = [
        new URL("assets/ferienwohnung/more/living_room3.jpg", import.meta.url),
        new URL("assets/ferienwohnung/more/table.jpg", import.meta.url),
        new URL("assets/ferienwohnung/more/table2.jpg", import.meta.url),
        new URL("assets/ferienwohnung/more/living_room2.jpg", import.meta.url),
        new URL("assets/ferienwohnung/more/sofa.jpg", import.meta.url),
        new URL("assets/ferienwohnung/more/patio.jpg", import.meta.url),
        new URL("assets/ferienwohnung/more/bedroom2.jpg", import.meta.url),
        new URL("assets/ferienwohnung/more/outside4.jpg", import.meta.url),
        new URL("assets/ferienwohnung/more/front.jpg", import.meta.url)
    ];


    const basic_room_more_pictures_button =
      document.getElementById("basic_room_more_pictures");
    const family_room_more_pictures_button =
      document.getElementById("family_room_more_pictures");
    const ferienwohnung_more_pictures_button =
      document.getElementById("ferienwohnung_more_pictures");
    const gallery_images = document.getElementsByClassName("gallery_img");

    for (const element of gallery_images) {
        element.addEventListener("click", e => {
            const options = { index: element, event: e }
            blueimp.Gallery(gallery_images, options);
        });
    }

    basic_room_more_pictures_button?.addEventListener("click", e => {
        blueimp.Gallery(room_basic_more_pictures, {});
    });
    family_room_more_pictures_button?.addEventListener("click", e => {
        blueimp.Gallery(room_family_more_pictures, {});
    });
    ferienwohnung_more_pictures_button?.addEventListener("click", e => {
        blueimp.Gallery(ferienwohnung_more_pictures, {});
    });
}


// Set up the overlays...

const body = document.body;
const overlay_bg = document.getElementById("overlay_bg");
const overlay_inner = overlay_bg.firstElementChild;

overlay_bg.onclick = e => {
    if (e.target === overlay_bg)
        hide_overlay();
}


export function show_overlay(child_to_be_displayed) {
    if (typeof(child_to_be_displayed) === "string") {
        child_to_be_displayed = document.getElementById(child_to_be_displayed);
        if (child_to_be_displayed === null)
            throw new Error("show_overlay called with ID that does not exist");
    }

    hide_children_of_overlay();
    show(child_to_be_displayed);
    show(overlay_bg);
    set_scrolling_on_body(false);
}

export function hide_overlay() {
    hide(overlay_bg);
    set_scrolling_on_body(true);
}

// Hides all children of overlay except those marked with the class "shared"
function hide_children_of_overlay() {
    for (const child of overlay_inner.childNodes) {
        if (child.classList && !child.classList.contains("shared"))
            hide(child);
    }
}

function show(node, isVisible) {
    const _isVisible = (isVisible === undefined || isVisible);
    node.classList.toggle("hidden_by_code", !_isVisible);
}

function hide(node) {
    node.classList.add("hidden_by_code");
}

function set_scrolling_on_body(is_scrolling_enabled) {
    body.classList.toggle("overflow-hidden", !is_scrolling_enabled);
}


// Set up EasePick for the date range picker.

const $ = query => document.getElementById(query);
let easepicker = null;

export async function init_datepicker(locale, night, nights) {
    let dates = [];
    const result = await fetch("https://storage.googleapis.com/gretelnieders.firebasestorage.app/available_dates.json");
    if (result.ok) {
        const json = await result.json();
        if (Array.isArray(json))
            dates = json;
        else throw new Error(`Dates had unexpected value: ${json}`);
    } else throw new Error(`Failed to load dates. Status: ${result.status}`)


    const wide_query = window.matchMedia(`(min-width: 900px)`);
    rebuild(wide_query.matches);
    wide_query.addEventListener("change", e => rebuild(e.matches));


    function rebuild(is_wide) {
        try {
            let start_date = easepicker?.getStartDate();
            let end_date = easepicker?.getEndDate();
            easepicker?.destroy();

            easepicker = new easepick.create({
                element: $("checkinout"),
                inline: true,
                calendars: 2,
                grid: is_wide ? 2 : 1,
                lang: locale,
                format: "DD MMMM YYYY",
                plugins: [RangePlugin, LockPlugin],
                css: [
                    "https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css"
                ],
                RangePlugin: {
                    tooltipNumber(num) {
                        return num - 1;
                    },
                    locale: {
                        one: night,
                        other: nights
                    }
                },
                LockPlugin: {
                    minDays: 2,
                    minDate: new Date(),
                    inseparable: true,
                    filter(date) {
                        const day_before = new Date(date);
                        day_before.setDate(date.getDate() - 1);
                        return date > new Date()
                          && dates.length !== 0
                          && !dates.includes(format_date_for_html(date))
                          && !dates.includes(format_date_for_html(day_before));
                    }
                },
                setup(picker) {
                    picker.on("select", update_price);
                }
            });

            if (start_date !== undefined) {
                easepicker.setStartDate(start_date);
                easepicker.setEndDate(end_date);
            }

            show($("error__calendar_failed_to_load"), false);

            const css = new CSSStyleSheet();
            css.replaceSync(".day { min-width: 40px !important; }");
            easepicker.ui.shadowRoot.adoptedStyleSheets.push(css);
        } catch (e) {
            console.error(e);
        }
    }
}


// Booking...

const is_production = (process.env.NODE_ENV !== "development");
let api = "https://gretel-nieders-2egcwilfoq-oa.a.run.app";
if (!is_production) {
    console.log("Using local Firebase Functions API on port 5001.");
    api = "http://127.0.0.1:5001/gretelnieders/europe-west6/gretel_nieders";
}
let language = "English";

const booking_form = $("booking_form");
const booking_wait_note = $("wait_notification");
const booking_error_note = $("error_notification");
const booking_success_note = $("success_notification");
const booking_submit_button = $("booking_submit");

const price_calculation_variables = [
  $("room_count"), $("adult_count"), $("child_count"), $("toddler_count")
];


booking_form?.addEventListener("submit", e => {
    e.preventDefault();
    _submit_booking();
});
for (const element of price_calculation_variables)
    element?.addEventListener("input", update_price);


export function set_language(new_language) {
    language = new_language;
}

function update_price() {
    const form = new FormData(booking_form);
    const _start = easepicker && easepicker.getStartDate();
    const _end = easepicker && easepicker.getEndDate();
    const _adults = form.get("adult_count") ?? "1";
    const _children = form.get("child_count") ?? "0";
    const _toddlers = form.get("toddler_count") ?? "0";
    const _rooms = form.get("room_count") ?? "1";

    const adults = Number.parseInt(_adults);
    const children = Number.parseInt(_children);
    const toddlers = Number.parseInt(_toddlers);
    const rooms = Number.parseInt(_rooms);

    const is_filled_out = (!!_start && !!_end);
    const [nights, christmas_nights] =
      (is_filled_out ? get_nights_info(_start, _end) : [0, 0]);
    const r = new PriceCalculation(
      adults, children, toddlers, rooms, nights, christmas_nights
    );

    const has_negative_duration = is_filled_out && nights < 0;
    const has_zero_duration = is_filled_out && nights === 0;
    const is_too_long = is_filled_out && nights > 365;
    const has_error =
      r.has_error || has_negative_duration || has_zero_duration || is_too_long;
    const done = is_filled_out && !has_error;

    // Pricing
    const has_christmas_nights = done && r.christmas_nights > 0;
    // If every night is a christmas night, the normal nightly price is never
    // charged, so we only show the christmas price.
    const has_normal_nights = !has_christmas_nights || r.christmas_nights < r.nights;
    show($("note_single_adult_rooms"), r.single_rooms > 0);
    show($("note_single_night"), done && r.nights === 1);
    show($("note_christmas_nights"), has_christmas_nights);
    show($("price_per_night_paragraph"), (!done || r.nights > 0) && has_normal_nights);
    show($("christmas_price_per_night_paragraph"), has_christmas_nights);
    show($("total_price_paragraph"), done);
    show($("price_info_incomplete"), !done);
    $("price_per_night").innerText = print_price(language, r.cost_per_night);
    $("christmas_price_per_night").innerText =
      print_price(language, r.cost_per_christmas_night);
    if (done)
        $("total_price").innerText = print_price(language, r.total_cost);

    // Errors
    show($("error__negative_duration"), has_negative_duration);
    show($("error__zero_days"), is_filled_out && has_zero_duration);
    show($("error__too_long"), is_too_long);
    show($("error__too_few_adults"), r.too_few_adults);
    show($("error__too_few_rooms"), r.too_few_rooms);
    show($("error__any"), has_error);
}

function format_date_for_html(date) {
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();
    return `${yyyy}-${mm}-${dd}`;
}


// Submit

async function _submit_booking() {
    const checkin = format_date_for_html(easepicker.getStartDate());
    const checkout = format_date_for_html(easepicker.getEndDate());
    const form_data = new FormData(booking_form);
    const form_values = Object.fromEntries(form_data.entries());
    form_values["checkin"] = checkin;
    form_values["checkout"] = checkout;

    hide(booking_submit_button);
    show(booking_wait_note);

    const json = {
        language: language,
        booking_form: form_values
    };

    try {
        const response = await fetch(api, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(json)
        })

        if (!response.ok)
            throw new Error(
                `Form submission failed because of bad response ` +
                `(status: ${response.status}, ` +
                `body: ${response.body})`);

        hide(booking_error_note);
        hide(booking_wait_note);
        show(booking_success_note);
    } catch (e) {
        console.log("Booking error: ", e)
        hide(booking_wait_note);
        show(booking_error_note);
        show(booking_submit_button);
    }
}


document.addEventListener("DOMContentLoaded", () => {
    try { init_gallery(); } catch (e) { console.log(e); }
    try { init_map_component(); } catch (e) { console.log(e); }
    try { update_price(); } catch (e) { console.log(e); }
});
